const PRINTIFY_ROUTE_PREFIX = "/dropshipping/printify";
const PRINTIFY_PAGES = Object.freeze([
  "SellerPrintifyDashboard", "SellerPrintifySettings", "SellerPrintifyConnection",
  "DropshippingSuppliers", "DropshippingSupplierProducts", "SellerPrintifyProducts",
  "SellerPrintifyProductDetails", "DropshippingImportedProducts", "SellerPrintifyOrders",
  "DropshippingApiErrors", "DropshippingAdmin",
]);
module.exports = { PRINTIFY_ROUTE_PREFIX, PRINTIFY_PAGES };
